import * as angular from "angular";
import { Group } from "../../models/group.model";
import { Integration } from "../../models/integration.model";
import { IntegrationDataProvider } from "../../data-provider/integration.dp";
import { Utils } from "../../helper/utils.helper";

let IntegrationLogin = {
    selector: "vcIntegrationLogin",
    templateUrl:
        "/angular/components/integration/integration-login.component.html",
    bindings: {},
    controller: class IntegrationLoginController {
        public installed = false;
        public loading = true;
        public active_tab = "main";
        public product_name: string;
        public groups: Group[] = [];
        public audiences: any = null;
        public integrationKey: string;
        public integrationName = "";
        public login_loading = false;
        public fields: any;
        public error: string | null;

        private readonly $scope: any;
        private readonly $window: any;
        public readonly __env: any;
        public readonly utils: Utils;
        private dataProvider: IntegrationDataProvider;

        constructor(
            $scope: any,
            $window: any,
            $routeParams: any,
            __env: any,
            IntegrationDataProvider: IntegrationDataProvider,
            Utils: Utils
        ) {
            Utils.runWootric();

            this.$scope = $scope;
            this.$window = $window;
            this.__env = __env;
            this.utils = Utils;
            this.dataProvider = IntegrationDataProvider;

            this.product_name = __env.product_name;
            this.integrationKey = $routeParams.integrationKey;

            this.dataProvider
                .getLoginFields(this.integrationKey)
                .then((fields: any) => (this.fields = fields));

            this.dataProvider
                .getIntegration(this.integrationKey)
                .then(
                    (integration: Integration) =>
                        (this.integrationName = integration.title)
                );
        }

        $onInit() {
            this.$scope.$watch(
                () => this.fields,
                (newValue: any, oldValue: any) => {
                    if (newValue && newValue !== oldValue) {
                        this.error = null;
                    }
                },
                true
            );
        }

        loginSubmit(): void {
            this.login_loading = true;
            let data = {};
            angular.forEach(this.fields, (field: any) => {
                data[field.name] = field.value;
            });
            data["id"] = this.integrationKey;
            this.dataProvider.login(data).then(
                () => {
                    this.dataProvider.clearAll();
                    this.$window.location =
                        "/#/integration/" + this.integrationKey;
                },
                () => {
                    this.login_loading = false;
                    this.error = "These credentials were not recognised";
                }
            );
        }
    },
};

angular
    .module("integration")
    .component(IntegrationLogin.selector, IntegrationLogin);
